import { createContext, useContext } from "react"
import { InstantSearchConfig, CollectionPageConfig } from "./types";

export const ConfigContext = createContext<InstantSearchConfig | CollectionPageConfig | undefined>(undefined);

export function useConfig() {
  const context = useContext(ConfigContext)
  if (context === undefined) {
    throw new Error('useConfig must be used within ???? app!')
  }
  return context
}